import { apiRequestWithAutoRefresh } from '../utils/apiUtils'

export interface Notification {
  id: string
  userId?: string
  type: string
  title: string
  message: string
  data?: any
  isRead: boolean
  createdAt: string
}

export interface NotificationPreferences {
  id: string
  userId: string
  timesheetReminder: boolean
  timesheetOverdue: boolean
  timesheetDeadlineApproaching: boolean
  timesheetRevisionDeadline: boolean
  timesheetSubmitted: boolean
  timesheetApproved: boolean
  timesheetRejected: boolean
  budgetWarning: boolean
  budgetExceeded: boolean
  workTimeWarning: boolean
  createdAt: string
  updatedAt: string
}

export interface NotificationList {
  notifications: Notification[]
  total: number
  unreadCount: number
}

export const notificationService = {
  // 獲取用戶通知列表
  async getNotifications(params?: {
    limit?: number
    offset?: number
    unreadOnly?: boolean
  }): Promise<NotificationList> {
    try {
      const queryParams = new URLSearchParams()
      if (params?.limit) queryParams.append('limit', params.limit.toString())
      if (params?.offset) queryParams.append('offset', params.offset.toString())
      if (params?.unreadOnly) queryParams.append('unreadOnly', 'true')

      const response = await apiRequestWithAutoRefresh(`/api/notifications?${queryParams.toString()}`)
      return response.data || { notifications: [], total: 0, unreadCount: 0 }
    } catch (error) {
      console.error('Error fetching notifications:', error)
      return { notifications: [], total: 0, unreadCount: 0 }
    }
  },

  // 獲取未讀通知數量
  async getUnreadCount(): Promise<number> {
    try {
      const response = await apiRequestWithAutoRefresh('/api/notifications/unread-count')
      return response.data?.count || 0
    } catch (error) {
      console.error('Error fetching unread count:', error)
      return 0
    }
  },

  // 標記通知為已讀
  async markAsRead(notificationId: string): Promise<void> {
    await apiRequestWithAutoRefresh(`/api/notifications/${notificationId}/read`, {
      method: 'POST'
    })
  },

  // 標記所有通知為已讀
  async markAllAsRead(): Promise<void> {
    await apiRequestWithAutoRefresh('/api/notifications/read-all', {
      method: 'POST'
    })
  },

  // 獲取通知偏好設置
  async getPreferences(): Promise<NotificationPreferences> {
    const response = await apiRequestWithAutoRefresh('/api/notifications/preferences')
    return response.data
  },

  // 更新通知偏好設置
  async updatePreferences(preferences: Partial<NotificationPreferences>): Promise<NotificationPreferences> {
    const response = await apiRequestWithAutoRefresh('/api/notifications/preferences', {
      method: 'PUT',
      body: JSON.stringify(preferences)
    })
    return response.data
  }
}
